import { DestinationDetails, DestinationDto } from '@gtpl/shared-models/masters';
import {Injectable} from '@nestjs/common';
import { Countries } from '../../countries/countries.entity';
import { Destination } from '../destination.entity';
import { DestinationDTO } from './destination.dto';

@Injectable()
export class DestinationAdapter {
    /**
     * 
     * @param DestinationDTO 
     * @param isUpdate 
     * @returns 
     */

        convertDtoToEntity( destinationDTO: DestinationDTO, isUpdate: boolean = false): Destination {
        try{

        const destination = new Destination();
        // destination.destinationId=destinationDTO.destinationId;
        destination.destinationName=destinationDTO.destinationName;
        destination.CountriesInfo= new Countries();
        destination.CountriesInfo.countryId = destinationDTO.countryId;
        destination.isActive=destinationDTO.isActive==undefined?true:destinationDTO.isActive;
        if (isUpdate){
            destination.destinationId=destinationDTO.destinationId;
            destination.updatedUser = destinationDTO.updatedUser;
        }else {
            destination.isActive = true;
            destination.createdUser=destinationDTO.createdUser;
        }
        return destination;
    }
    catch (Error){
        return Error;
    }
}
    public convertEntityToDto( destinationData: Destination): DestinationDTO{
        const destination = new DestinationDTO();
        destination.destinationId=destinationData.destinationId;
        destination.destinationName=destinationData.destinationName;
        if(destinationData.CountriesInfo){
            destination.countryId=destinationData.CountriesInfo.countryId;
            destination.countryName=destinationData.CountriesInfo.countryName;
        }
        destination.isActive=destinationData.isActive;
        destination.createdAt=destinationData.createdAt;
        destination.createdUser=destinationData.createdUser;
        destination.updatedAt=destinationData.updatedAt;
        destination.updatedUser=destinationData.updatedUser;
        destination.versionFlag=destinationData.versionFlag;
        return destination;
    }

}